import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32563716"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "problem-solution" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "problem-solution__video"
}
const _hoisted_5 = { key: 1 }

import { computed, onMounted, ref, Ref } from 'vue';
import { BtnsForTabsMenuType } from '@/types';
import { useUserStore } from '@/store/modules/user';
import { FaqFromBackType, FaqListFromBackType } from '@/api/support/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProblemSolution',
  setup(__props) {

const isLoading = ref(false);
const activeComponentBtnId: Ref<undefined | string | number> = ref(undefined);
const componentBtns: Ref<BtnsForTabsMenuType[]> = ref([]);
const faqList: Ref<FaqListFromBackType> = ref({});

const changeActiveBtn = (btnId: string | number) => {
  activeComponentBtnId.value = btnId;
};

const getGAQById = (): FaqFromBackType[] | undefined => {
  if (activeComponentBtnId.value) {
    return faqList.value[activeComponentBtnId.value];
  }

  return undefined;
};

const preparedComponentBtns = computed((): BtnsForTabsMenuType[] => {
  return componentBtns.value.filter(el => !el.hide);
});

onMounted(async () => {
  isLoading.value = true;
  const res = await useUserStore().getFAQList();

  if (res) {
    Object.entries(res.categories).forEach(el => {
      componentBtns.value.push({
        id: el[0],
        title: el[1],
        hide: !res.list[el[0]].length,
      });
    });
    faqList.value = res.list;
  }
  changeActiveBtn(componentBtns.value[0].id);
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_base_video_link = _resolveComponent("base-video-link")!
  const _component_base_expansion_panels = _resolveComponent("base-expansion-panels")!
  const _component_base_menu_with_tabs = _resolveComponent("base-menu-with-tabs")!

  return (preparedComponentBtns.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_base_menu_with_tabs, {
          activeComponent: activeComponentBtnId.value,
          componentBtns: preparedComponentBtns.value,
          bgColor: "#fff",
          withRadius: "",
          onChangeActiveBtn: _cache[0] || (_cache[0] = ($event: any) => (changeActiveBtn($event)))
        }, {
          content: _withCtx((contentProps) => [
            _createElementVNode("div", _hoisted_2, [
              (getGAQById()?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getGAQById(), (category) => {
                      return (_openBlock(), _createBlock(_component_base_expansion_panels, {
                        key: category.id,
                        styleType: "simple"
                      }, {
                        title: _withCtx((titleProps) => [
                          _createElementVNode("div", null, _toDisplayString(category.title), 1)
                        ]),
                        content: _withCtx((contentProps) => [
                          (category.video)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_base_video_link, {
                                    id: `supportvideo${category.id}`,
                                    "you-tube": category.video
                                  }, null, 8, ["id", "you-tube"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(category.text), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, "Данные отсутствуют"))
            ])
          ]),
          _: 1
        }, 8, ["activeComponent", "componentBtns"])
      ]))
    : _createCommentVNode("", true)
}
}

})